module.exports = __webpack_public_path__ + "static/media/model.e27f6dc3.svg";